import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Prices from './components/Prices';
import Services from './components/Services';
import Contact from './components/Contact';

function App() {
  return (
    <AdminProvider>
      <Router>
        <div style={{ 
          fontFamily: "'Inter', sans-serif",
          backgroundColor: '#fff',
          color: '#121212',
          lineHeight: 1.6,
          overflowX: 'hidden'
        }}>
          <style>
            {`
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              
              body {
                font-family: 'Inter', sans-serif;
                background-color: #fff;
                color: #121212;
                line-height: 1.6;
                overflow-x: hidden;
              }
              
              a {
                text-decoration: none;
              }
              
              .container {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 24px;
              }
              
              :root {
                --uber-black: #000000;
                --ola-lime: #d4ed31;
                --uber-blue: #276ef1;
                --soft-gray: #f7f7f7;
                --border-color: #eeeeee;
                --text-main: #121212;
                --text-muted: #6b6b6b;
                --radius-sm: 8px;
                --radius-md: 16px;
                --radius-lg: 24px;
                --shadow: 0 10px 30px rgba(0,0,0,0.08);
              }
            `}
          </style>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;